import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[hbDynamicComponentHost]',
})
export class DynamicComponentDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
